// extracted by mini-css-extract-plugin
module.exports = {"gift-pack-code":"h6PqDnOCna","button-style":"_2QCNKtNExE"};